import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadingService } from 'src/app/_services/local/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './app-loading.component.html',
    styleUrls: ['./app-loading.component.scss']
})
export class AppLoadingComponent {

    @ViewChild('modal', { static: false }) modal: ModalDirective;

    isShown: boolean;
    label: string;
  
    private isLoaded: boolean;

    constructor(private loadingService: LoadingService) {
        this.loadingService
            .getStatusLoading()
            .subscribe(show => {
                this.onCall(show);
            });
    }

    ngAfterViewInit() {

        this.isLoaded = true;
    
        if (this.isShown !== undefined)
          this.changeModalVisibility();
      }
    
      private onCall(show: boolean) {
    
        this.isShown = show;
       
        if (this.isLoaded)
          this.changeModalVisibility();
      }
    
      private changeModalVisibility() {
    
        if (this.isShown)
          this.modal.show();
        else
          this.modal.hide();
      }
}
